import { render } from "./PlusInCircleIcon.vue?vue&type=template&id=366c052a&scoped=true"
import script from "./PlusInCircleIcon.vue?vue&type=script&lang=js"
export * from "./PlusInCircleIcon.vue?vue&type=script&lang=js"

import "./PlusInCircleIcon.vue?vue&type=style&index=0&id=366c052a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-366c052a"

export default script